import {
  PRODUCT_NEW_FORM_CONFIG_LOADED,
  PRODUCT_NEW_FORM_CONFIG_CLEAR,
  PRODUCT_NEW_FORM_BULK_CONFIG_LOADED,
  PRODUCT_NEW_FORM_BULK_CONFIG_CLEAR,
  PRODUCT_NEW_SEARCHES_TEAMS_LOADED,
  PRODUCT_NEW_SEARCHES_TEAMS_CLEAR,
} from '../../../actions/actionTypes';

const initialState = {
  formConfig: null,
  bulkFormConfig: null,
  companyTeams: null,
};

const productNewForm = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCT_NEW_FORM_CONFIG_LOADED:
      return { ...state, formConfig: action.payload.formConfig };

    case PRODUCT_NEW_FORM_CONFIG_CLEAR:
      return { ...state, formConfig: null };

    case PRODUCT_NEW_FORM_BULK_CONFIG_LOADED:
      return { ...state, bulkFormConfig: action.payload.bulkFormConfig };

    case PRODUCT_NEW_FORM_BULK_CONFIG_CLEAR:
      return { ...state, bulkFormConfig: null };

    case PRODUCT_NEW_SEARCHES_TEAMS_LOADED:
      return { ...state, companyTeams: action.payload.teams };

    case PRODUCT_NEW_SEARCHES_TEAMS_CLEAR:
      return { ...state, companyTeams: null };

    default:
      return state;
  }
};

export default productNewForm;
